import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="w-full bg-cream py-14 sm:py-20" data-id="element-279" data-mp="3mg0p6vskt9jm">
      <div className="mx-auto w-full max-w-5xl px-4" data-id="element-280" data-mp="3r78zdu1qcyxu">
        <SectionHeading eyebrow="⭐ Real clinicians" title="What dentists say after organizing their first case" data-id="element-281" data-mp="3r8tr7bwnu3s0" />

        <ul className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2" data-id="element-282" data-mp="42jblkd62eh8">
          {testimonials.map((testimonial, index) => <li key={testimonial.name} className={`flex h-full flex-col rounded-3xl border border-navy-100 bg-white p-5 sm:p-6 ${index === 0 ? 'md:col-span-2' : ''}`} data-id="element-283" data-mp="92xkf4mldsgb" data-mpi={index}>
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-284" data-mp="2avdg81lvu2sa">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-sky-500 text-sky-500" aria-hidden="true" data-id="element-285" data-mp="1sl2nlxb0rw13" data-mpi={i} />)}
              </div>

              <blockquote className={`mt-3 flex-1 leading-relaxed text-navy-700 ${index === 0 ? 'text-base sm:text-xl' : 'text-sm sm:text-base'}`} data-id="element-286" data-mp="1ivreiao4urd7">
                “{testimonial.quote}”
              </blockquote>

              <div className="mt-5 flex items-center gap-3 border-t border-navy-100 pt-4" data-id="element-287" data-mp="26jslhf5nxzqi">
                <img src={testimonial.photo} alt={testimonial.name} className="h-12 w-12 shrink-0 rounded-full object-cover" width={96} height={96} data-id="element-288" data-mp="22igtj2zbh2f5" />
                <div className="min-w-0" data-id="element-289" data-mp="r4v3lflmuwsk">
                  <p className="truncate text-sm font-extrabold text-navy-800" data-id="element-290" data-mp="m3xm758g66s4">
                    {testimonial.name}
                  </p>
                  <p className="truncate text-xs font-medium text-navy-500" data-id="element-291" data-mp="nm5q6mlyrvo2">
                    {testimonial.role} · {testimonial.location}
                  </p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mt-10 flex justify-center" data-id="element-292" data-mp="imjb07mks5cm">
          <CTAButton label="Join them for $27" data-id="element-293" data-mp="ikyguj46aofa" />
        </div>
      </div>
    </section>;
}